import globalStore from '$$store/main';

function onCalendarIntegrationCreated(event) {
  if (+GT.user.id === +event.data.userId) {
    if (event.data.type === 'google') {
      globalStore.commit('integrationGoogle/addNewLink', event.data);
    } else {
      globalStore.commit('integrationOutlook/addNewLink', event.data);
    }
  }
}

export default onCalendarIntegrationCreated;
